var _circle, _circle2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 21,
    viewBox: "0 0 44 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.8137,
    cy: 15.0793,
    r: 3.92308,
    stroke: "white",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.7356,
    cy: 15.0793,
    r: 3.92308,
    stroke: "white",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7308 15.0769H28.8077M7.23077 15.0769H3C2.44771 15.0769 2 14.6292 2 14.0769V11.118C2 10.7393 2.214 10.393 2.55279 10.2236L5.71193 8.64403C5.85079 8.57461 6.0039 8.53846 6.15914 8.53846H10.1795C10.388 8.53846 10.5912 8.47334 10.7608 8.35219L19.3931 2.18627C19.5627 2.06512 19.7659 2 19.9743 2H31.7338C31.9562 2 32.1722 2.07412 32.3478 2.21065L37.6907 6.36628C37.8662 6.5028 38.0823 6.57692 38.3046 6.57692H41.5385C42.0907 6.57692 42.5385 7.02464 42.5385 7.57692V14.0769C42.5385 14.6292 42.0907 15.0769 41.5385 15.0769H36.6538",
    stroke: "white",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7959 7.62424L20.1805 4.70116C20.2627 4.64641 20.3592 4.61719 20.4579 4.61719H24.3834C24.6596 4.61719 24.8834 4.84104 24.8834 5.11719V8.04026C24.8834 8.31641 24.6596 8.54026 24.3834 8.54026H16.0733C15.5786 8.54026 15.3843 7.89865 15.7959 7.62424Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.478 7.64255L31.6415 4.71947C31.5544 4.65312 31.4479 4.61719 31.3384 4.61719H28.0024C27.7263 4.61719 27.5024 4.84104 27.5024 5.11719V8.04026C27.5024 8.31641 27.7263 8.54026 28.0024 8.54026H35.175C35.6536 8.54026 35.8587 7.9326 35.478 7.64255Z",
    stroke: "white",
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleWhite);
export default __webpack_public_path__ + "static/media/vehicleWhite.2c1c45b9.svg";
export { ForwardRef as ReactComponent };